module.exports = __webpack_public_path__ + "static/media/ancr.6332b389.svg";